export default __webpack_public_path__ + "static/media/Icon-document.e2243cf2.svg";